import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";

@Injectable()
export class RemoveUserBetUseCase implements IUseCase<number, void> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(betIndex: number): void {
       this.roundRepository.removeUserBet(betIndex);
    }
}
